import type { IconData } from '@stacksjs/iconify-core'

export const leftIndentAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 19h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2m0-4h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2m0-8h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2m0 4h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M9 19a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v12a1 1 0 0 1-1 1m-4-4.333a1 1 0 0 1-.64-.231l-2-1.667a1 1 0 0 1 0-1.538l2-1.667a1 1 0 0 1 1.28 1.538L4.562 12l1.078.898A1 1 0 0 1 5 14.667\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default leftIndentAlt
